export const translations = {
  hr: {
    nav: {
      about: "O meni",
      services: "Usluge",
      repertoire: "Repertoar",
      gallery: "Galerija",
      testimonials: "Preporuke",
      faq: "Pitanja",
      contact: "Kontakt",
    },
    hero: {
      eyebrow: "Obrt za glazbene usluge · Đakovo",
      title_a: "AMALI",
      title_b: "Glazba koja dira dušu",
      subtitle: "Profesionalna vokalistica Valeria Jacek. Emocija, energija i besprijekorna izvedba za vaše najljepše trenutke — vjenčanja u salama, rođendani, privatne proslave i vikend live nastupi po kafićima diljem Hrvatske.",
      cta_primary: "Rezerviraj termin",
      cta_secondary: "Saznaj više",
      scroll: "Pomakni dolje",
      featured_label: "Iza mene je",
      featured: ["Sudjelovanje na natjecanjima", "Festivalski nastupi", "Live izvedbe", "Studijska snimanja"],
    },
    about: {
      eyebrow: "O meni",
      heading: "Glas oblikovan godinama strasti",
      paragraph: "Glazba je moj životni put od kada znam za sebe. Moje ime je Valeria Jacek, imam 25 godina, a pjevanjem se aktivno bavim već desetak godina. Kroz godine odrastanja, moj glas je oblikovan kroz brojna glazbena natjecanja, festivale i nastupe koji su mi donijeli bogato iskustvo i stopostotnu sigurnost na pozornici. Kroz obrt 'AMALI' pretvaram svoju ljubav prema glazbi u profesionalnu uslugu, donoseći emociju, energiju i vrhunsku izvedbu na svaki vaš događaj.",
      stats: [
        { value: "10+", label: "godina pjevanja" },
        { value: "100+", label: "nastupa" },
        { value: "∞", label: "emocija" },
      ],
      signature: "— Valeria Jacek",
    },
    services: {
      eyebrow: "Usluge",
      heading: "Glazbena ponuda po mjeri",
      items: [
        {
          title: "Vjenčanja & svadbe",
          desc: "Emotivna izvedba vaših omiljenih pjesama tijekom prvog plesa, svadbene proslave i ostalih ključnih trenutaka u sali ili restoranu.",
          features: ["Svadbena proslava", "Prvi ples", "Sala / restoran", "Personalizirani repertoar"],
        },
        {
          title: "Rođendani & proslave",
          desc: "Profesionalna glazbena podloga za rođendane, godišnjice, korporativne eventove i sve vrste privatnih zabava.",
          features: ["Rođendanske proslave", "Godišnjice & krštenja", "Korporativni eventi", "Privatne zabave"],
        },
        {
          title: "Kafići & klubovi",
          desc: "Vikend live nastupi u kafićima, lounge barovima i klubovima — opuštena ili energična atmosfera, prema potrebi mjesta.",
          features: ["Vikend live setovi", "Lounge & cocktail atmosfera", "Acoustic / pjevana glazba", "Gostujući nastupi"],
        },
      ],
    },
    repertoire: {
      eyebrow: "Repertoar",
      heading: "Od šansone do svjetskih hitova",
      desc: "Pažljivo biran repertoar prilagođen vašem događaju — od emotivnih ceremonija do energičnih zabava.",
      tags: [
        "Pop", "Pop-rock", "Jazz", "Soul", "R&B", "Latino",
        "Domaće hitove", "Svjetske hitove", "Šansone", "Klape & narodne",
        "Acoustic ballade", "Wedding klasike",
      ],
    },
    gallery: {
      eyebrow: "Galerija",
      heading: "Trenuci s pozornice",
      desc: "Pogled iza kulisa nastupa, vjenčanja i posebnih trenutaka.",
    },
    testimonials: {
      eyebrow: "Preporuke",
      heading: "Riječi zadovoljnih klijenata",
      items: [
        {
          quote: "Valeria je našem vjenčanju dala dušu. Kada je zapjevala naš prvi ples, suze su krenule same. Profesionalna, topla i nevjerojatno talentirana.",
          author: "Ana & Marko",
          role: "Vjenčanje, Osijek",
        },
        {
          quote: "Naš korporativni event je bio besprijekoran zahvaljujući AMALI ekipi. Energija i glas — sve na najvišoj razini.",
          author: "Ivan Horvat",
          role: "Event manager, Zagreb",
        },
        {
          quote: "Pjevala je na našoj proslavi i goste je doslovno digla na noge. Preporuka od srca!",
          author: "Marija K.",
          role: "30. rođendan, Đakovo",
        },
      ],
    },
    faq: {
      eyebrow: "Česta pitanja",
      heading: "Sve što trebate znati",
      items: [
        {
          q: "Kako rezervirati termin?",
          a: "Ispunite kontakt formu ili nas pozovite na +385 99 350 9595. Nakon potvrde dostupnosti, šaljemo personaliziranu ponudu i ugovor.",
        },
        {
          q: "Putujete li izvan Đakova?",
          a: "Da, dostupna sam za nastupe diljem Hrvatske i regije. Putni troškovi se dogovaraju prema lokaciji događaja.",
        },
        {
          q: "Mogu li birati pjesme s repertoara?",
          a: "Apsolutno. Repertoar prilagođavamo vašim željama i karakteru događaja. Posebni zahtjevi su uvijek dobrodošli.",
        },
        {
          q: "Imate li vlastitu opremu?",
          a: "Surađujem s provjerenim tehničkim timovima i mogu organizirati ozvučenje za manje i veće događaje.",
        },
        {
          q: "Koliki je avans za rezervaciju?",
          a: "Termin se potvrđuje uplatom od 30% iznosa. Ostatak se podmiruje neposredno prije ili nakon nastupa, prema dogovoru.",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      heading: "Razgovarajmo o vašem događaju",
      desc: "Ispunite formu ili nas kontaktirajte direktno putem WhatsApp-a, telefona ili Instagrama.",
      form: {
        name: "Ime i prezime",
        email: "Email adresa",
        phone: "Telefon (opcionalno)",
        event_type: "Tip događaja",
        event_date: "Datum događaja",
        message: "Poruka",
        submit: "Pošalji upit",
        sending: "Šaljem...",
        success: "Hvala! Upit je zaprimljen. Javljam se uskoro.",
        error: "Greška pri slanju. Pokušajte ponovno ili nas nazovite.",
        placeholder_event: "Vjenčanje / Event / Domjenak...",
        placeholder_message: "Recite mi nešto o događaju, lokaciji i željama...",
      },
      direct: {
        whatsapp: "WhatsApp",
        phone: "Pozovi",
        instagram: "Instagram",
        email: "Email",
      },
      info: {
        name: "AMALI, obrt za glazbene usluge",
        owner: "Vlasnica: Valeria Jacek",
        location: "Đakovo, Hrvatska",
        phone: "+385 99 350 9595",
        instagram: "@valeria_jacek",
      },
    },
    footer: {
      tagline: "Glazba koja dira dušu.",
      rights: "Sva prava pridržana.",
      made: "Izrađeno s ljubavlju prema glazbi.",
    },
    floating: {
      whatsapp: "WhatsApp",
      call: "Nazovi sada",
      book_now: "Rezerviraj",
    },
    cta_banner: {
      eyebrow: "Slobodni termini",
      heading: "Vaš datum vrijedi razgovora.",
      desc: "Provjerite dostupnost za vjenčanje, event ili proslavu. Odgovaram unutar 24 sata.",
      primary: "Pošalji upit",
      secondary: "WhatsApp odmah",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      repertoire: "Repertoire",
      gallery: "Gallery",
      testimonials: "Reviews",
      faq: "FAQ",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Professional Music Services · Đakovo",
      title_a: "AMALI",
      title_b: "Music that touches the soul",
      subtitle: "Professional vocalist Valeria Jacek. Emotion, energy and flawless live performance for your most precious moments — wedding receptions, birthdays, private celebrations and weekend live shows at lounges across Croatia.",
      cta_primary: "Book a date",
      cta_secondary: "Learn more",
      scroll: "Scroll down",
      featured_label: "Behind me",
      featured: ["Music competitions", "Festival performances", "Live shows", "Studio sessions"],
    },
    about: {
      eyebrow: "About",
      heading: "A voice shaped by passion",
      paragraph: "Music has been my path for as long as I can remember. My name is Valeria Jacek, I'm 25, and I have been actively singing for roughly ten years. Through countless competitions, festivals and live performances, my voice has been polished and my stage confidence sharpened. Through AMALI, I turn my love for music into a refined service — bringing emotion, energy and excellence to every event.",
      stats: [
        { value: "10+", label: "years of singing" },
        { value: "100+", label: "performances" },
        { value: "∞", label: "emotion" },
      ],
      signature: "— Valeria Jacek",
    },
    services: {
      eyebrow: "Services",
      heading: "Tailor-made musical experiences",
      items: [
        {
          title: "Weddings & Receptions",
          desc: "Emotional performances of your favourite songs during the first dance, wedding reception and other key moments in the hall or restaurant.",
          features: ["Wedding reception", "First dance", "Hall / restaurant", "Personalized setlist"],
        },
        {
          title: "Birthdays & Celebrations",
          desc: "Refined live music for birthdays, anniversaries, corporate events and every kind of private celebration.",
          features: ["Birthday parties", "Anniversaries & baptisms", "Corporate events", "Private parties"],
        },
        {
          title: "Cafés & Clubs",
          desc: "Weekend live sets at cafés, lounge bars and clubs — laid-back or energetic atmosphere, tailored to the venue.",
          features: ["Weekend live sets", "Lounge & cocktail vibe", "Acoustic / vocal-led", "Guest appearances"],
        },
      ],
    },
    repertoire: {
      eyebrow: "Repertoire",
      heading: "From chanson to global hits",
      desc: "A carefully curated repertoire tailored to your event — from intimate ceremonies to energetic celebrations.",
      tags: ["Pop", "Pop-rock", "Jazz", "Soul", "R&B", "Latin", "Croatian hits", "World hits", "Chanson", "Acoustic ballads", "Wedding classics", "Folk"],
    },
    gallery: {
      eyebrow: "Gallery",
      heading: "Moments on stage",
      desc: "A glimpse behind the scenes of performances, weddings and unforgettable nights.",
    },
    testimonials: {
      eyebrow: "Reviews",
      heading: "Words from happy clients",
      items: [
        {
          quote: "Valeria gave our wedding soul. The moment she sang our first dance, tears came on their own. Professional, warm and incredibly talented.",
          author: "Ana & Marko",
          role: "Wedding, Osijek",
        },
        {
          quote: "Our corporate event was flawless thanks to AMALI. The energy and voice — everything at the highest level.",
          author: "Ivan Horvat",
          role: "Event manager, Zagreb",
        },
        {
          quote: "She performed at our celebration and quite literally got everyone on their feet. Heartfelt recommendation!",
          author: "Marija K.",
          role: "30th birthday, Đakovo",
        },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      heading: "Everything you need to know",
      items: [
        {
          q: "How do I book a date?",
          a: "Fill out the contact form or call us at +385 99 350 9595. After confirming availability, we'll send a personalized offer and contract.",
        },
        {
          q: "Do you travel outside Đakovo?",
          a: "Yes — I'm available for performances across Croatia and the region. Travel costs depend on the location of the event.",
        },
        {
          q: "Can I choose songs from the repertoire?",
          a: "Absolutely. We tailor the setlist to your taste and the spirit of the event. Special requests are always welcome.",
        },
        {
          q: "Do you bring your own equipment?",
          a: "I work with trusted technical teams and can arrange sound for both small and large events.",
        },
        {
          q: "What deposit is required?",
          a: "The date is confirmed with a 30% deposit. The remainder is paid just before or after the performance, as agreed.",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      heading: "Let's talk about your event",
      desc: "Fill in the form or reach out directly via WhatsApp, phone or Instagram.",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "Phone (optional)",
        event_type: "Event type",
        event_date: "Event date",
        message: "Message",
        submit: "Send inquiry",
        sending: "Sending...",
        success: "Thank you! Your inquiry was received. I'll get back to you soon.",
        error: "Something went wrong. Please try again or call us.",
        placeholder_event: "Wedding / Event / Reception...",
        placeholder_message: "Tell me a bit about your event, location and wishes...",
      },
      direct: {
        whatsapp: "WhatsApp",
        phone: "Call",
        instagram: "Instagram",
        email: "Email",
      },
      info: {
        name: "AMALI, music services",
        owner: "Owner: Valeria Jacek",
        location: "Đakovo, Croatia",
        phone: "+385 99 350 9595",
        instagram: "@valeria_jacek",
      },
    },
    footer: {
      tagline: "Music that touches the soul.",
      rights: "All rights reserved.",
      made: "Crafted with love for music.",
    },
    floating: {
      whatsapp: "WhatsApp",
      call: "Call now",
      book_now: "Book",
    },
    cta_banner: {
      eyebrow: "Available dates",
      heading: "Your date deserves a conversation.",
      desc: "Check availability for your wedding, event or private celebration. I reply within 24 hours.",
      primary: "Send inquiry",
      secondary: "WhatsApp now",
    },
  },
};

export const useT = (lang) => translations[lang] || translations.hr;
